<template>
  <div>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">NEW BANK FINANCE</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-form ref="form" class="multi-col-validation mt-6">
        <v-layout row wrap class="align-center mx-2 ">
          <v-flex xs12 md3>
            <v-select
              v-model="category_id"
              class="mx-2"
              dense
              outlined
              label="Category"
              :items="category_items"
              item-value="id"
              item-text="category"
              @change="selected_category"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
          <v-flex xs12 md3>
            <v-select
              v-model="bank_id"
              class="mx-2"
              dense
              outlined
              label="Bank"
              :items="bank_items"
              item-value="id"
              item-text="bank_code"
              @change="selected_bank"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="align-center mx-2 ">
          <v-flex xs12 md4>
            <v-text-field
              class="mx-2"
              v-model="account_no"
              label="Account Number"
              dense
              outlined
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              class="mx-2"
              v-model="account_name"
              label="Account Name"
              dense
              outlined
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-toolbar dense dark color="primary" class="mt-5 mb-5">
          <v-toolbar-title><h4 class="font-weight-light">DATA</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-layout row wrap class="align-center mx-2">
          <v-flex xs12 md3>
            <v-text-field
              class="mx-2"
              v-model="date"
              label="Date"
              dense
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="date"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              class="mx-2"
              v-model="pn_no"
              label="PN #"
              dense
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              class="mx-2"
              v-model="principal"
              label="Principal Amount"
              dense
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="number"
              min="0"
              @change="calculation"
              @keyup="calculation"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              class="mx-2"
              v-model="interest_rate"
              label="Interest Rate"
              dense
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="number"
              min="0"
              @change="calculation"
              @keyup="calculation"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md3>
            <v-text-field
              class="mx-2"
              v-model="period_from"
              label="Period From"
              dense
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="date"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md3>
            <v-text-field
              class="mx-2"
              v-model="period_to"
              label="Period To"
              dense
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="date"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              class="mx-2"
              v-model="interest_due"
              label="Total Interest"
              dense
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="number"
              min="0"
              @change="calculation"
              @keyup="calculation"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              class="mx-2"
              v-model="principal_amort_due"
              label="Monthly Ammortization"
              dense
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="number"
              min="0"
              @change="calculation"
              @keyup="calculation"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              class="mx-2"
              v-model="total"
              label="Total"
              dense
              outlined
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              class="mx-2"
              v-model="remarks"
              label="Remarks"
              dense
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <!-- alert -->
        <v-col cols="12" v-show="alert">
          <v-alert
            color="warning"
            text
            class="mb-0"

          >
            <div class="d-flex align-start">
              <v-icon color="warning">
                {{ icons.mdiAlertOutline }}
              </v-icon>

              <div class="ms-3">
                <p class="text-base font-weight-medium mb-1">
                  {{ alert_message }}
                </p>
              </div>
            </div>
          </v-alert>
        </v-col>

        <v-col cols="12">
          <v-btn
            color="primary"
            class="me-3 mt-4"
            @click="save_employee"
            v-if="!saving"
          >
            Save changes
          </v-btn>
          <v-progress-circular
            :size=50
            :width="5"
            color="primary"
            indeterminate
            v-else
          ></v-progress-circular>
        </v-col>
      </v-form>
    </v-card>
    <snack-bar-dialog
      :snackbar_flag="this.snackbar"
      :color="this.snackbar_color"
      :snackbar_text="this.snackbar_text"
    />
  </div>
</template>

<script>
import {mdiCheck, mdiClose} from "@mdi/js";
import moment from "moment";
import {mapActions, mapGetters} from "vuex";
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

const initialState = () => {
  return {
    saving: false,
    alert: false,
    alert_message: '',

    category_id: '',
    category_items: [],
    bank_id: 0,
    bank_items: [],
    account_name: '',
    account_no: '',

    date: '',
    pn_no: '',
    principal: '',
    interest_rate: '',
    interest_due: '',
    period_from: '',
    period_to: '',
    principal_amort_due: '',
    total: '',
    remarks: '',
  }
}
export default {
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      icons: {
        mdiCheck,
        mdiClose,
      },
    }
  },
  data() {
    return initialState()
  },
  mounted() {
    this.initialize_data()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('bank_transaction', [
      'initialization_cash_flow',
    ]),
    ...mapActions('bank_finance', [
      'register_bank_finance',
    ]),
    reset() {
      Object.assign(this.$data, initialState())
      this.initialize_data()
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    initialize_data() {
      this.initialization_cash_flow({
        employee_id: this.employee_id,
      })
        .then(response => {
          this.category_items = response.data
          this.category_id = ''
          this.bank_id = ''
          this.bank_items = []
          this.account_name = ''
          this.account_no = ''
        })
        .catch(error => {
          console.log(error)
        })
    },
    selected_category(value) {
      var index = this.category_items
        .map(function (x) {
          return x.id
        })
        .indexOf(value)
      if (index != -1) {
        this.bank_items = this.category_items[index].bank_depository
      }
    },
    selected_bank() {
      var index = this.bank_items
        .map(function (x) {
          return x.id
        })
        .indexOf(this.bank_id)
      if (index != -1) {
        this.account_name = this.bank_items[index].bank_name
        this.account_no = this.bank_items[index].account_no
      }
    },
    calculation() {
      this.total = parseFloat(this.principal) +parseFloat(this.interest_due)
    },
    save_employee() {
      this.saving = true
      this.alert = false
      if (this.$refs.form.validate()) {
        let name = this.account_name
        var index = this.bank_items
          .map(function (x) {
            return x.id
          })
          .indexOf(this.bank_id)
        if (index != -1) {
          name = this.bank_items[index].bank_code+' ('+this.bank_items[index].account_no+')'
        }
        const data = new FormData()
        data.append('bank_id', this.bank_id);
        data.append('date', this.date);
        data.append('name', name);
        data.append('pn_no', this.pn_no);
        data.append('principal', this.principal);
        data.append('interest_rate', this.interest_rate);
        data.append('period_from', this.period_from);
        data.append('period_to', this.period_to);
        data.append('no_of_days', 0);
        data.append('interest_due', this.interest_due);
        data.append('principal_amort_due', this.principal_amort_due);
        data.append('total_due', this.principal_amort_due);
        data.append('total', this.total);
        data.append('remarks', this.remarks);
        this.register_bank_finance(data)
          .then(response => {
            var color = 'success'
            if (response.status === 201) {
              color = 'error'
            }
            this.change_snackbar({
              show: true,
              color: color,
              text: response.data,
            })
            this.saving = false
            this.reset()
          })
          .catch(error => {
            this.alert = true
            this.alert_message = error
            this.saving = false
          })
      } else {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving = false
      }
    }
  },
}
</script>
